import { withCompInfo } from '@wix/editor-elements-integrations'
import type { AppPartCss } from './AppPart'

export const css = withCompInfo<AppPartCss, never>()([], () => ({
	height: 'auto',
}))
